import rules from './rules';

/**
 * Register all custom validation rules
 * @param {Object} Validator - VeeValidate Validator instance
 */
const registerValidationRules = (Validator) => {
  rules.forEach(rule => {
    Validator.extend(rule.name, {
      validate: rule.validate,
      message: rule.message,
      params: rule.params || []
    });
  });
};

export { registerValidationRules };
export * from './rules';
